require('./bootstrap');

require('./components/imageComponent');
require('./components/menuComponent');
require('./components/repeaterComponent');
require('./components/switchComponent');
require('./components/tagifyComponent');

// noUiSlider
window.noUiSlider = require('nouislider');
require('nouislider/dist/nouislider.css');

// import Paginator from './components/Paginator';
// window.Paginator = Paginator;
